import {defaultUiSchema} from "../ui-schema/default.ui.schema";

export const micrositesUiSchema = {
  label: "Microsites",
  ...defaultUiSchema
};
